import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FrontendNetworkService } from './frontend-network.service';

@NgModule({
  imports: [
    CommonModule
  ],
  providers: [FrontendNetworkService],
})
export class FrontendNetworkModule { }
